import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faArrowRightFromBracket } from "@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";
import { faXmark } from "@fortawesome/pro-solid-svg-icons/faXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAuth } from "../contexts/AuthContext";

const DISMISS_MS = 4000;

function LoginToast() {
  const { t } = useTranslation("common", { keyPrefix: "auth" });
  const {
    user,
    showWelcomeToast,
    dismissWelcomeToast,
    showSignOutToast,
    dismissSignOutToast,
  } = useAuth();

  useEffect(() => {
    if (!showWelcomeToast) return;
    const timer = setTimeout(dismissWelcomeToast, DISMISS_MS);
    return () => clearTimeout(timer);
  }, [showWelcomeToast, dismissWelcomeToast]);

  useEffect(() => {
    if (!showSignOutToast) return;
    const timer = setTimeout(dismissSignOutToast, DISMISS_MS);
    return () => clearTimeout(timer);
  }, [showSignOutToast, dismissSignOutToast]);

  if (showSignOutToast) {
    return (
      <div
        role="status"
        aria-live="polite"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-lg bg-cm-charcoal-1 px-4 py-3 shadow-lg login-toast-enter"
        style={{ maxWidth: "360px" }}
      >
        <FontAwesomeIcon
          icon={faArrowRightFromBracket}
          className="shrink-0 text-cm-charcoal-4"
          style={{ fontSize: "1.1rem" }}
        />
        <span className="flex-1 text-sm font-medium text-white">
          {t("signedOut")}
        </span>
        <button
          onClick={dismissSignOutToast}
          aria-label={t("close")}
          className="shrink-0 text-white/60 hover:text-white transition-colors"
          style={{ fontSize: "0.9rem", background: "none", border: "none", cursor: "pointer", padding: 0 }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
    );
  }

  if (!showWelcomeToast || !user) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-lg bg-cm-charcoal-1 px-4 py-3 shadow-lg login-toast-enter"
      style={{ maxWidth: "360px" }}
    >
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="shrink-0 text-green-400"
        style={{ fontSize: "1.1rem" }}
      />
      <span className="flex-1 text-sm font-medium text-white">
        {t("welcomeBack", { name: user.name ?? user.email })}
      </span>
      <button
        onClick={dismissWelcomeToast}
        aria-label={t("close")}
        className="shrink-0 text-white/60 hover:text-white transition-colors"
        style={{ fontSize: "0.9rem", background: "none", border: "none", cursor: "pointer", padding: 0 }}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </div>
  );
}

export default LoginToast;
